import axios from 'axios'
import Utils from '@/common/utils'

const url = `${process.env.VUE_APP_BASE_API}/api`
const headers = { Authorization: Utils.setLocalToken() }

export default class ProductService {
  static async getProducts () {
    const { data } = await axios.get(`${url}/products`, { headers })
    return data
  }
}
